// Identifica em qual sistema eletrônico o processo tramita (PJe, e-SAJ, eproc, Projudi...)
// a partir do link da comunicação e, na falta dele, do tribunal.

const BY_TRIBUNAL: Record<string, string> = {
  TJSP: 'e-SAJ',
  TJMS: 'e-SAJ',
  TJAL: 'e-SAJ',
  TJAM: 'e-SAJ',
  TJAC: 'e-SAJ',
  TJSC: 'eproc',
  TJRS: 'eproc',
  TJTO: 'eproc',
  TRF2: 'eproc',
  TRF4: 'eproc',
  TJPR: 'Projudi',
  TJGO: 'Projudi',
};

export interface JudicialSystemInfo {
  /** Ex.: "PJe" */
  system: string;
  /** Ex.: "1º grau" */
  degree: string | null;
  /** Ex.: "PJe · TJPE · 1º grau" */
  label: string;
}

export function detectJudicialSystem(link: string | null | undefined, tribunal: string): JudicialSystemInfo {
  const url = (link || '').toLowerCase();
  let system = '';
  if (url.includes('pje')) system = 'PJe';
  else if (url.includes('esaj')) system = 'e-SAJ';
  else if (url.includes('eproc')) system = 'eproc';
  else if (url.includes('projudi')) system = 'Projudi';
  else if (url.includes('tucujuris')) system = 'Tucujuris';
  if (!system) system = BY_TRIBUNAL[(tribunal || '').toUpperCase()] || 'PJe';

  let degree: string | null = null;
  if (/pje1g|\/1g\/|1g\.|1grau/.test(url)) degree = '1º grau';
  else if (/pje2g|\/2g\/|2g\.|2grau/.test(url)) degree = '2º grau';

  const label = [system, tribunal, degree].filter(Boolean).join(' · ');
  return { system, degree, label };
}

/** Compara nomes ignorando acentos, espaços extras e maiúsculas */
export const normalizePersonName = (value?: string | null) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
